import React from 'react';
import { BookX, Frown, Eye, HeartCrack } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: BookX,
    text: 'Evita leer'
  }, {
    icon: Frown,
    text: 'Se frustra cuando intenta'
  }, {
    icon: Eye,
    text: 'Empieza a compararse'
  }, {
    icon: HeartCrack,
    text: 'Pierde confianza'
  }];
  return <section className="w-full bg-cream-dark py-20 md:py-28 px-4" data-id="element-107">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-108">
        {/* Content Side */}
        <div className="order-2 md:order-1 space-y-10" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-dark leading-tight" data-id="element-110">
            Lo que empieza como frustración… puede convertirse en una creencia
            peligrosa.
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-111">
            {problems.map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-olive flex items-center space-x-4" data-id="element-112">
                <item.icon className="w-6 h-6 text-olive shrink-0" data-id="element-113" />
                <span className="font-sans text-dark font-medium" data-id="element-114">
                  {item.text}
                </span>
              </div>)}
          </div>

          <div className="bg-terracotta p-8 rounded-xl text-center shadow-lg transform -rotate-1" data-id="element-115">
            <p className="text-white font-serif italic text-xl md:text-2xl" data-id="element-116">
              "Y lo más delicado: empieza a creer que no es capaz."
            </p>
          </div>
        </div>

        {/* Image Side */}
        <div className="order-1 md:order-2 flex justify-center md:justify-end" data-id="element-117">
          <div className="relative max-w-md w-full" data-id="element-118">
            <div className="absolute top-4 -right-4 w-full h-full border-2 border-olive/20 rounded-2xl -z-10" data-id="element-119"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gWZYbowipLzsasD4BeB82y/frustracion.jpg" alt="Niño frustrado con la lectura" className="w-full h-auto rounded-2xl shadow-lg object-cover aspect-[4/5]" data-id="element-120" />
          </div>
        </div>
      </div>
    </section>;
}